import React from "react";
import { Container, Title } from "./ServicosPage";
import Footer from "../../components/Footer";
import construcao from "../../images/construcao.png";

const Servicos = () => {
  return (
    <>
      <Container>
        <Title></Title>
        <img src={construcao} alt="Em construção" />
      </Container>
      <Footer />
    </>
  );
};

export default Servicos;
